const TAB_VALUES = {
  live: "live",
  review: "under_review",
  closed: "close_reject",
  draft: "draft"
};

export default TAB_VALUES;
